import { render, staticRenderFns } from "./SurveySentCount.vue?vue&type=template&id=b15d7c10"
import script from "./SurveySentCount.vue?vue&type=script&lang=js"
export * from "./SurveySentCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports